export const ConfirmContent = {
  dashboardLinkText: 'View my dashboard',
  inheritanceTaxBanner: {
    heading: `Inheritance tax`,
    prelinkText: `According to the information you provided, the decedent is a resident of a state with inheritance tax requirements. As a result, you may need to provide additional documentation prior to receiving your inheritance. Please visit the website for the`,
    linkText: `State of `,
    linkURL: {
      PA: `https://www.revenue.pa.gov/TaxTypes/InheritanceTax/Pages/default.aspx`,
      NJ: `https://www.state.nj.us/treasury/taxation/inheritance-estate/inheritance.shtml`,
    },
    postlinkText: `to review the state's inheritance tax requirements. Note: The inheritance tax requirement from the decedent's state of residence may result in additional processing time.`,
  },
  internalTransfer: {
    upNext: `Up next`,
    pageTitle: `We've received your request!`,
    pageTitleSingleSigner: `We've started your transfer!`,
    pageTitleForMultiSigner: `Just a few more steps before your transfer is complete`,
    receiptTitle: `Transfer summary`,
    beneCard: {
      header: `Take action`,
      body: `Help save your loved ones from future hassle and ensure your hard-earned wealth is protected for the long haul.`,
      buttonLink: 'https://beneficiary.web.vanguard.com/welcome',
      alt: `Two individuals passing a large coin to another individual`,
    },
    businessDays: {
      stpEligible: `1-3 business days`,
      notStpEligible: `5-7 business days`,
    },
    listDescriptionForSingleSigner: [
      {
        header: `Vanguard will process the request. Typically this takes <strong><BUSINESS_DAYS></strong>. You'll receive confirmation once it's complete.`,
      },
      {
        header: `The investments are available in the receiving account.`,
        dashboardLinkText: `View my dashboard`,
      },
    ],
    listDescriptionForMultiSigner: [
      {
        header: `We'll need signatures from additional owners/trustees`,
        description: `Required signers will receive a message with a link to e-sign. They’ll need to be web registered with Vanguard to access it. Check your <MESSAGE_CENTER_LINK> for more guidance.`,
      },
      {
        header: `We process the request in <BUSINESS_DAYS>`,
        description: `We’ll need all signatures within 7 business days. Once we receive them, we’ll begin processing your request! `,
      },
      {
        header: `Investments are available in the receiving account`,
        description: `You’ll receive confirmation once the transfer is complete.`,
        dashboardLinkText: `View my dashboard`,
      },
    ],
  },
  inheritedIRA: {
    oaPageTitle: `Your account has been opened!`,
    s24FailureSteps: [
      {
        text: `Vanguard will process the request and open your account. Typically this takes 1-3 business days. You’ll receive confirmation once it’s complete.`,
        noLink: true,
      },
      {
        text: `Once you receive your account number, let your executor or trustee know you’re ready to receive the assets.`,
      },
    ],
    s24SuccessSteps: [
      {
        text: `Let your executor or trustee know your account is ready to receive assets. They’ll need your account number to complete the disbursement!`,
      },
    ],
  },
  pageTitleMinor: `Congratulations! We've started your transfer.`,
  pageTitle: `Thank you. We've received your inheritance transfer.`,
  pageTitleIRAExecutor: `Your inheritance transfer request has been submitted`,
  s24: {
    pageTitle: `In approximately 3-5 business days, we'll email you the status of your new account. To prevent further delay, do not re-submit another transfer request. When you log in after the account is open, you'll need to complete your registration and you'll be prompted to sign up for electronic delivery of documents.`,
  },
  continueButton: `Continue`,
  step1Header: `Step 1`,
  step2Header: `Step 2`,
  step3Header: `Step 3`,
  step4Header: `Step 4`,
  step5Header: `Step 5`,
  stepSubmitDescription: `Submit your request online: 10 minutes`,
  stepSubmitDescriptionAltTag: `Your request has been submitted`,
  stepAccountDescription: `Finish the account set-up process`,
  stepAccountDescriptionAltTag: `Use the link below to finish the account set-up process`,
  stepProcessDescription: `Vanguard processes transfer: 5-7 business days`,
  stepProcessDescriptionIRAExecutor: `We'll process your transfer in 5-7 business days and reach out if we need more info`,
  stepProcessDescriptionAltTag: `The processing of your transfer will take 5 to 7 business days`,
  stepFundsDescription: `Funds are available in your account`,
  stepFundsDescriptionIRAExecutor: `Assets are available in your account`,
  stepFundsDescriptionAltTag: `Once the transfer is complete, funds will be available in your account`,
  stepBeneNewAcctDescription: `Each beneficiary opens a new individual account`,
  stepBeneNewAcctDescriptionAltTag: `Each beneficiary will need to open a new individual account`,
  stepContactUsTransferDescription: `Contact us and we'll transfer the assets from the estate account to each beneficiary`,
  stepContactUsTransferDescriptionAltTag: `Once each beneficiary has opened an account, contact us and we'll transfer the assets from the estate account to each beneficiary`,
  stepAssetsArriveDescription: `Assets arrive in the accounts for each beneficiary`,
  stepAssetsArriveDescriptionAltTag: `After all steps have been completed, assets will arrive in the accounts for each beneficiary`,
  finishAccountButton: {
    link: '/us/LogonLogoff',
    label: `Log on to finish setting up your account`,
  },
  estate: {
    estateNextHeader: `What you should do next`,
    estateNextDescription: `If you'll be transferring investments from the estate account to beneficiaries, you'll want to ask each beneficiary to open a zero-balance individual nonretirement account on <span class="bold"><a class="link-underline" href="https://personal.vanguard.com">vanguard.com</a></span>`,
    estateShareLinkButton: `Share link to open account`,
    estateTransferCompleteDescription: `Once the transfer from the decedent's account to the estate account is complete, and all beneficiaries have opened individual nonretirement accounts, please call us at <span class="bold">877-662-7447</span> and we can then finalize any remaining inheritance transfers to the beneficiaries.`,
  },
  nextHeader: `What would you like to do next?`,
  nextOptions: {
    accounts: `View my accounts`,
    advisor: `Partner with an advisor`,
    bene: `Update beneficiaries`,
    anotherRequest: `Submit another request`,
  },
  clientHeader: `Additional reminders`,
  clientButtons: {
    header: `What would you like to do now?`,
    headerIRAExecutor: `What would you like to do next?`,
    buttons: [
      {
        label: `Go to your account summary`,
        link: `balances`,
      },
      {
        label: `Inherit another account`,
        link: `overview`,
      },
    ],
  },
  adviceButton: {
    label: `See my advice options`,
    link: `https://investor.vanguard.com/advice/compare-investment-advice`,
  },
  shareWithBeneficiaries: {
    pageTitle: `Inheritance transfer pending`,
    subHeader: `We'll complete the transfer once we receive inheritance applications from all beneficiaries`,
    description: `If you haven't already, you'll want to communicate with the other beneficiaries and let them know they should complete this same online process.`,
  },
  digitalAdvice: {
    pageSubtitle: `We've started your transfer and enrolled you in digital advisor!`,
    pageDescription: {
      part1: `While your money is moving into your account, visit your `,
      part2: ` to further personalize your investment settings! `,
      linkText: `Digital Advisor dashboard`,
      link: `https://digital-advisor.vanguard.com/dashboard`,
    },
    banner: {
      header: `Digital Advisor enrollment error`,
      description: `Unfortunately, we couldn't enroll you in Digital Advisor right now. We'll notify you soon about your enrollment status.`,
    },
    steps: [
      `Submit your request`,
      `Vanguard processes transfer: 5-7 business days`,
      `Funds are available in the account`,
      `Digital Advisor will begin investing`,
    ],
  },
  beneficiaryAdoption: {
    pageTitleMinor: `Congratulations!`,
    pageSubtitleMinor: `We've started your transfer.`,
    pageDescriptionMinor: `Shape your financial future by controlling what you can. Adding a beneficiary is one proactive step you can take to ensure your account’s protected no matter what life throws your way. It only takes a few minutes!`,
    steps: [
      `Submit your request`,
      `Vanguard processes transfer: `,
      `Add a beneficiary (optional)`,
      `Funds are available in the account`,
    ],
    time: [`1-3 business days`, `5-7 business days`],
    imgAltText: `Woman stepping towards a flag surrounded by coins`,
    button: `Add a beneficiary`,
    buttonLink: `https://beneficiary.web.vanguard.com/welcome`,
  },
  cashOnConfirm: {
    steps: [
      `Submit your request`,
      `Vanguard processes transfer: `,
      `Funds are available in the account`,
    ],
    time: [`1-3 business days`, `5-7 business days`],
  },
  importantThings: {
    header: `IMPORTANT THINGS TO DO NEXT`,
    ira: {
      rmd: {
        header: `<strong>Find out if you need to take a RMD</strong>`,
        description1: `Because you've transferred an IRA into your name as a beneficiary, you'll generally be required to take a required minimum distribution, or RMD.`,
        description2: ` and get the important information you'll need.`,
        link: `https://investor.vanguard.com/inherit/ira-rmd`,
        linkAlt: `Learn more about RMDs`,
      },
    },
    joint: {
      costBasis: {
        nonspouse: {
          part1: `We'll carry over your cost basis from your joint account. You can request an adjustment in cost basis by completing our `,
          part2: ` Please consult a tax advisor for guidance on adjusting cost basis for inherited shares.`,
          link: `https://personal.vanguard.com/forms/v115.pdf?2210147160`,
        },
        spouse: {
          part1: `We'll update your cost basis to our default calculation for spouses inheriting a joint account (50% of each position will be updated to the fair market value as of the date of death). You can request a change to the default calculation by completing our `,
          part2: ` Please consult a tax advisor for guidance on adjusting cost basis for inherited shares.`,
          link: `https://personal.vanguard.com/forms/v115.pdf?2210147160`,
        },
      },
    },
    individual: {
      costBasis: {
        header: `<strong>Learn more about cost basis</strong>`,
        description: `The cost basis on any eligible inherited shares will be updated to the fair market value as of the date of death. Please consult a tax advisor for guidance on inheriting shares.`,
      },
    },
    costBasis: {
      header: `<strong>Learn more about cost basis</strong>`,
      learnMore1: `If you'd like to learn more about cost basis, `,
      learnMore2: ` of our website.`,
      link: `https://investor.vanguard.com/taxes/cost-basis`,
    },
    advice: {
      description1: `And remember, if you need financial advice during a time like this, know that we're here to help. We offer `,
      description2: ` if you need help navigating this important life event.`,
      pasLink: `https://investor.vanguard.com/financial-advisor/financial-advice`,
      daLink: `https://investor.vanguard.com/financial-advisor/digital-advisor`,
    },
  },
  disclosure: {
    personalAdvisorServices: `Vanguard Personal Advisor Services is provided by Vanguard Advisers, Inc., a registered investment advisor, or by Vanguard National Trust Company, a federally chartered, limited purpose trust company.`,
    digitalAdvisorServices: `Vanguard Digital Advisor's services are provided by Vanguard Advisers, Inc. ("VAI"), a federally registered investment advisor. VAI is a subsidiary of VGI and an affiliate of VMC. All investing is subject to risk, including the possible loss of the money you invest. Neither VAI nor Digital Advisor guarantees profits or protection from losses.`,
  },
  ariaLabels: {
    accountSettingButton: 'Go to account settings',
    adviceButton: 'Go to advice page',
    anotherRequest: 'Submit another request',
  },
  beneOnFile: {
    subHeader: 'Missing beneficiaries',
    header: ', leave a lasting legacy.',
    beneInfo:
      'Did you know 15 million dollars worth of client assets go unclaimed each year due to missing beneficiary elections? Make sure only you get a say in who benefits from your hard-earned wealth-it only takes a few minutes.',
    button: 'Add beneficiary',
    stepDescription: 'Add a beneficiary',
    stepAltDescription:
      'A star icon on a golden background indicating the step of adding beneficiaries to an account.',
    beneImageAlt: 'Outline of two busts with a dollar icon to signify beneficiary to account.',
    buttonHref: `https://beneficiary.web.vanguard.com/welcome`,
  },
  trustCostBasisStepBanner: {
    preLinkText: `Your trust may be eligible for a cost basis step up. Please consult a tax advisor to verify and then `,
    linkText: `complete this form.`,
    linkURL: `https://personal1.vanguard.com/forms/v115.pdf`,
  },
  cashOnConfirmFooter: `**The Vanguard Cash Plus bank sweep program APY (annual percentage yield) is 3.65% effective January 6, 2025. The APY will vary and may change at any time. Source for average bank savings yield of 0.42%: FDIC National Rates and Rate Caps as of December 16, 2024. There may be other material differences between these products that must be considered prior to investing.`,
  receiptContent: {
    profileDescription: `If you have changes to your profile, you can update some of your information online by going to your <a class="link-underline" href="{{link}}">profile and account settings.</a>`,
    transferFromAndTo: {
      transferringFromLabel: 'Transferring from',
      transferringToLabel: 'Transferring to',
      accountTypeLabel: 'Account type',
      accountRegistrationLabel: 'Account registraiton',
      accountNumberLabel: 'Account number',
      accountNumberPendingLabel: 'Account number pending',
      dividendsAndCapitalGainsLabel: 'Dividends & capital gains',
      reinvestDistributions: 'Reinvest distributions',
      settlementFundLabel: 'Settlement fund',
      fundInvestWarning: `You could lose money by investing in the Fund. Although the Fund seeks to preserve the value of your investment at $1.00 per share, it cannot guarantee it will do so. An investment in the Fund is not a bank account and is not insured or guaranteed by the Federal Deposit Insurance Corporation or any other government agency. The Fund's sponsor is not required to reimburse the Fund for losses, and you should not expect that the sponsor will provide financial support to the Fund at any time, including periods of market stress.`,
      settlementFundDescription: `Your settlement fund (also known as a "sweep fund") is used to pay for investments and hold assets from investment sales and other transactions.`,
      learnMore: 'Learn more',
      close: 'Close',
    },
    openInheritedIraAccount: {
      originalAccountLabel: 'Original account info',
      previouslyInheritedLabel: 'Previously inherited',
      yes: 'Yes',
      no: 'No',
      iraTypeLabel: 'IRA Type',
      previouslyInheritedIraTypes: {
        nonRoth: 'Inherited IRA',
        roth: 'Inherited Roth IRA',
      },
      notPreviouslyInheritedIraTypes: {
        nonRoth: 'Traditional, Simple, or SEP IRA',
        roth: 'Roth IRA',
      },
      decedentNameLabel: `Decedent's name`,
      originalDecedentNameLabel: `Original decedent's name`,
      newAccountLabel: 'New account info',
      inheritedIRA: 'Inherited IRA',
      inheritedRothIRA: 'Inherited Roth IRA',
      sourceOfFunds: 'Source of funds',
      inheritance: 'Inheritance',
    },
    profile: {
      profileLabel: 'Profile',
      nameLabel: 'Name',
      emailLabel: 'Email',
      dateOfBirthLabel: 'Date of birth',
      citizenshipLabel: 'Citizenship',
      countryOfCitizenshipLabel: 'Country of citizenship',
      socialSecurityNoLabel: 'Social Security number',
      primaryResidenceLabel: 'Primary residence',
      mailingAddressLabel: 'Mailing address',
      primaryPhoneLabel: 'Primary phone',
      profileAccountSettingsLabel: '',
    },
    employment: {
      employmentLabel: 'Employment',
      employmentStatusLabel: 'Status',
      employerLabel: 'Employer',
      occupationLabel: 'Occupation',
      businessStreetAddressLabel: 'Business street address',
      companyNameLabel: 'Company name',
      natureOfBusinessLabel: 'Nature of business',
      spouseIsVgEmployeeLabel: 'Spouse is a Vanguard employee',
      associatedPersonLabel: 'Associated person',
      controlPersonLabel: 'Control person',
      yes: 'Yes',
      no: 'No',
    },
    financialProfile: {
      financialProfileLabel: 'Financial profile',
      investmentObjectiveLabel: 'Investment objective',
      incomeLabel: 'Income',
      netWorthLabel: 'Net worth',
    },
  },
};
